import axios from 'axios';

import { responseEntityMapper } from '@qwealth/qcore';
import { REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

import { TradeRequestQueryParams, TradeRequestsResponse } from 'data/models/TradeRequest';

const TRADE_REQUESTS_BASE = process.env.REACT_APP_QWEALTH_LOCAL_V3_API || REACT_APP_QWEALTH_API_V3;

export const fetchTradeRequests = async (params?: TradeRequestQueryParams): Promise<TradeRequestsResponse> =>
  axios
    .get(`${TRADE_REQUESTS_BASE}/tradeRequests`, { params })
    .then(response => responseEntityMapper<TradeRequestsResponse>(response));
